import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import Select from '../Select';
import { SelectOptionType } from '../../../../types';
import { SelectProps } from '../Select/Select';

interface SelectNumberProps extends SelectProps {
  quantity: number,
  start: number,
  label?: string,
  pluralLabel?: string
};

const SelectNumber: React.FC<SelectNumberProps> = ({ quantity, start, label, pluralLabel, ...props }) => {

  const [selectOption, seSelectOptionType] = useState<SelectOptionType[]>([])

  useEffect(() => {
    initOptions();
  }, [])


  const initOptions = () => {
    const options: SelectOptionType[] = [];
    Array.from(Array(quantity)).forEach((item, index) => {
      const _value = start + index;
      const _label: string = label ? `${_value} ${_value <= 1 ? label : pluralLabel}` : (_value).toString() //`${_value} ${label && start == 0 ? label : pluralLabel}`;
      options.push({ label: _label, value: (_value).toString() })
    })
    seSelectOptionType(options);
  }

  return <Select options={selectOption} {...props} />;
};

SelectNumber.propTypes = {
  //
};

export default SelectNumber;
